// extracted by mini-css-extract-plugin
export default {"header":"FeedDetailsDisplayCard_header__A2bTU","root":"FeedDetailsDisplayCard_root__CCDxe"};